import {
  Injectable
} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor, HttpResponse, HttpErrorResponse
} from '@angular/common/http';
import {
  AuthService
} from './auth.service';
import {
  Observable
} from 'rxjs';
import {
  LoadingIndicatorService
} from '../../shared/layout/components/loading-indicator';
import {tap} from "rxjs/operators";
import {AwsSignatureInputData} from './aws-signature-input.model';
import {AwsSignatureService} from './aws-signature.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(public auth: AuthService, public aws: AwsSignatureService, public loadingService: LoadingIndicatorService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if ( request.url.indexOf('91c7ql6w0e' ) >= 0 && request.url.indexOf('test-emr') < 0) {
      //console.log("Updating emr request: " + JSON.stringify(request, null, 4));

      const endpoint = /(^https?:\/\/[^/]+)/g.exec(request["url"])[1];
      const pathComponent = (request["url"] || "").substring(endpoint.length);

      let signatureInput = new AwsSignatureInputData();
      signatureInput.canonicalUri = pathComponent;
      signatureInput.service = "execute-api";
      signatureInput.method = request["method"];
      if (request["content-type"]) {
        signatureInput.contentType = request["content-type"];
      }
      if (request["body"]) {
        signatureInput.body = JSON.stringify(request["body"]);
      }

      let signature = this.aws.generateSignature(signatureInput);
      console.log("Generating headers: " + Object.keys(signature) + " " + JSON.stringify(signature, null, 4));

      request = request.clone({
        setHeaders: signature
      });
      this.loadingService.update( request.urlWithParams, true );
    } else if ( request.url.indexOf('amazonaws.com' ) >= 0 && !request.url.includes('s3') && !request.url.includes('91c7ql6w0e')) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.auth.getToken()}`
        }
      });
      this.loadingService.update( request.urlWithParams, true );
    }

    return next
      .handle(request)
      .pipe(tap(
        (event) => {
          if (event instanceof HttpResponse) {
              this.loadingService.update((<HttpResponse<any>>event).url, false);
          } else if ( event instanceof  HttpErrorResponse ) {
              this.loadingService.update((<HttpErrorResponse>event).url, false);
          }
        }
      ));
  }
}
